import Vue from 'vue';
import VueRouter from 'vue-router';

import App from './App.vue';

import Index from './Index.vue';
import Imprint from './Imprint.vue';
import Privacy from './Privacy.vue';

Vue.config.productionTip = false;

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'index',
        component: Index
    },
    {
        path: '/imprint',
        name: 'imprint',
        component: Imprint
    },
    {
        path: '/privacy',
        name: 'privacy',
        component: Privacy
    }
];

const router = new VueRouter({
    mode: 'history',
    routes,
    scrollBehavior (to, from, savedPosition) {
        if(to.fullPath == '/imprint' || to.fullPath == '/privacy') {
            return { x: 0, y: 0};
        }

        return savedPosition;
    }
});

new Vue({
    render: h => h(App),
    router,
}).$mount('#app');
